import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { easeOut, popSpring } from '../../utils/styles';
const steps = ['Recovery path', 'Details', 'Confirm'];
interface StepProgressProps {
  step: number;
  className?: string;
}
export function StepProgress({
  step,
  className = ''
}: StepProgressProps) {
  const pct = step / (steps.length - 1) * 100;
  return <nav aria-label="Progress" className={className} data-id="element-208" data-mp="3evjhl33cv0co">
      <div className="relative" data-id="element-209" data-mp="3ey5px4y2ljvy">
        <div className="absolute left-12 right-12 top-[11px] h-1.5 overflow-hidden rounded-full bg-slate-200/80" data-id="element-210" data-mp="39xrhvmwgy9xx">
          <motion.div className="h-full rounded-full bg-gradient-to-r from-primary-600 to-accent-500" initial={false} animate={{
          width: `${pct}%`
        }} transition={{
          duration: 0.3,
          ease: easeOut
        }} data-id="element-211" data-mp="3nvzjw98d41fy" />
        </div>
        <ol className="relative flex justify-between" data-id="element-212" data-mp="1pho5bjz7x9nt">
          {steps.map((label, i) => {
          const state = i < step ? 'done' : i === step ? 'current' : 'upcoming';
          return <li key={label} className="flex w-24 flex-col items-center gap-2" aria-current={state === 'current' ? 'step' : undefined} data-id="element-213" data-mp="1j1zgz4k6arbo" data-mpi={i}>
                <motion.span initial={false} animate={{
              scale: state === 'current' ? 1.1 : 1
            }} transition={popSpring} className={`grid h-7 w-7 place-items-center rounded-full text-xs font-bold ring-4 ring-white transition-colors duration-200 ${state === 'done' ? 'bg-primary-700 text-white' : state === 'current' ? 'bg-white text-primary-700 shadow-[inset_0_0_0_2px_#0F766E]' : 'bg-slate-100 text-slate-400 shadow-[inset_0_0_0_1px_#E2E8F0]'}`} data-id="element-214" data-mp="1o0k6a8xvzqlc">
                  {state === 'done' ? <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-215" data-mp="hdyflxgsof4f" /> : i + 1}
                </motion.span>
                <span className={`whitespace-nowrap text-xs font-medium ${state === 'upcoming' ? 'text-slate-400' : 'text-slate-700'}`} data-id="element-216" data-mp="9cpmuxspub76">
                  {label}
                </span>
              </li>;
        })}
        </ol>
      </div>
    </nav>;
}